
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/free-to-be-young",
      function () {
        return require("private-next-pages/stories/free-to-be-young.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/free-to-be-young"])
      });
    }
  